export default class PromoBar {
    constructor() {
        this.promoBar = document.querySelector('.promo-bar');
        this.closeButton = document.querySelector('.promo-bar-close');
        this.addEventListeners();
    }

    addEventListeners() {
        if (this.closeButton && this.promoBar) {
            this.closeButton.addEventListener('click', () => {
                this.promoBar.style.display = 'none';
            });
        }
    }
}